// extracted by mini-css-extract-plugin
export default {"wrapper":"WordCloudWraper_wrapper__DnisB","words":"WordCloudWraper_words__qNyI9"};